import React from "react";

export interface IShowcaseFrameProps {
  title: string;
  componentName: string;
  sourcePath: string;
  description: string;
  children: React.ReactNode;
}

export const ShowcaseFrame: React.FC<IShowcaseFrameProps> = ({
  title,
  componentName,
  sourcePath,
  description,
  children
}: IShowcaseFrameProps): JSX.Element => {
  return (
    <article className="lab-frame">
      <header className="lab-frame__head">
        <div className="lab-frame__crumbs">
          <span className="lab-frame__crumb">components</span>
          <span className="lab-frame__crumb-sep">/</span>
          <span className="lab-frame__crumb lab-frame__crumb--active">{title.toLowerCase()}</span>
        </div>
        <h1 className="lab-frame__title">{title}</h1>
        <p className="lab-frame__desc">{description}</p>
        <dl className="lab-frame__meta">
          <div className="lab-frame__meta-row">
            <dt>component</dt>
            <dd>{componentName}</dd>
          </div>
          <div className="lab-frame__meta-row">
            <dt>source</dt>
            <dd>{sourcePath}</dd>
          </div>
        </dl>
      </header>
      <div className="lab-frame__body">{children}</div>
    </article>
  );
};
